import React, { useState, useMemo } from 'react';
import CustomLayout from '@/common/Layout';
import { TabTitle } from '../../../../../../utilities/helpers';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Card,
  Form,
  Row,
  Col,
  Spin,
  Select,
  DatePicker,
  message,
  Space
} from 'antd';

const { Option } = Select;
import styles from './index.module.less';
import FormItem from 'common/FormItem';
import { history } from '@/app/history';
import { create_declaration_config } from '../../../../redux/slice';
import FormData from 'form-data';
import moment from 'moment';

function CreateDeclarationConfigsFlow() {
  TabTitle('Gift Register - Create New RO Flow');

  const [form] = Form.useForm();

  const dispatch = useDispatch();

  const { create_declaration_configLoading } = useSelector(
    (state) => state.admin
  );

  const [filterPayload, setFilterPayload] = useState([moment(), moment()]);
  const [financialYear, setFinancialYear] = useState(null);

  // Generate financial years (10 before, current, 10 after)
  const generateFinancialYears = useMemo(() => {
    const currentDate = moment();
    const currentMonth = currentDate.month() + 1; // moment months are 0-indexed
    const currentYear = currentDate.year();

    // Financial year typically runs from April (month 4) to March
    // If current month is April or later, FY starts from current year
    // Otherwise, FY starts from previous year
    let currentFYStartYear;
    if (currentMonth >= 4) {
      currentFYStartYear = currentYear;
    } else {
      currentFYStartYear = currentYear - 1;
    }

    const financialYears = [];
    // Generate 10 years before, current year, and 10 years after (total 21 years)
    for (let i = -10; i <= 10; i++) {
      const fyStartYear = currentFYStartYear + i;
      const fyEndYear = fyStartYear + 1;
      const fyEndYearShort = fyEndYear.toString().slice(-2); // Last 2 digits
      const fyString = `${fyStartYear}-${fyEndYearShort}`;
      financialYears.push({
        value: fyString,
        label: fyString
      });
    }

    return financialYears;
  }, []);

  const onFinish = () => {
    if (!filterPayload || !filterPayload[0] || !filterPayload[1]) {
      message.error('Please select date range');
      return;
    }
    if (!financialYear) {
      message.error('Please select financial year');
      return;
    }

    const formdata = new FormData();
    const fromDate = moment(filterPayload[0]).format('YYYY-MM-DD');
    const toDate = moment(filterPayload[1]).format('YYYY-MM-DD');

    // Calculate giftsFrmDate and giftsToDate based on selected financial year
    const fyStartYear = parseInt(financialYear.split('-')[0], 10);
    const giftsFrmDate = `${fyStartYear}-04-01`;
    const giftsToDate = `${fyStartYear + 1}-03-31`;

    formdata.append('upldFrmDate', fromDate);
    formdata.append('upldToDate', toDate);
    formdata.append('fiscalYear', financialYear);
    formdata.append('giftsFrmDate', giftsFrmDate);
    formdata.append('giftsToDate', giftsToDate);

    dispatch(create_declaration_config(formdata)).then(function (response) {
      if (response?.payload?.success) {
        history.push('/declaration-configs-flow');
      }
    });
  };

  return (
    <CustomLayout>
      <Spin spinning={create_declaration_configLoading}>
        <div style={{ marginTop: '50px' }}>
          <Row className={`${styles.row_container_setting}`}>
            <div className={`${styles.gift_container}`}>
              <div className={`${styles.myGift_title_setting}`}>
                Add Declaration
              </div>
            </div>
          </Row>{' '}
          <div className={`${styles.container}`}>
            <div className={`${styles.cardContainer}`}>
              <Card className={`${styles.cardStyles_Container}`}>
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={onFinish}
                  className={`${styles.formstyles}`}
                >
                  <Card className={`${styles.cardStyles}`}>
                    <Row gutter={[16, 0]}>
                      {/* Select Date Range */}
                      <Col flex="70%">
                        <FormItem
                          label="Select Date Range"
                          name="fromDate"
                          rules={[
                            {
                              required: true,
                              message: 'Please enter date'
                            }
                          ]}
                        >
                          <DatePicker.RangePicker
                            format={'DD-MMM-YYYY'}
                            onChange={(x) => {
                              setFilterPayload(x);
                            }}
                            value={filterPayload}
                            style={{ width: '100%' }}
                            disabledDate={(current) =>
                              current &&
                              current.toDate() < new Date().setHours(0, 0, 0, 0)
                            }
                          />
                        </FormItem>
                      </Col>
                      {/* Select financial year */}
                      <Col flex="30%">
                        <FormItem
                          label="Select Financial Year"
                          name="financialYear"
                          rules={[
                            {
                              required: true,
                              message: 'Please select financial year'
                            }
                          ]}
                        >
                          <Select
                            placeholder="Select financial year"
                            value={financialYear}
                            onChange={(value) => {
                              setFinancialYear(value);
                              form.setFieldsValue({ financialYear: value });
                            }}
                            style={{ width: '100%' }}
                          >
                            {generateFinancialYears.map((fy) => (
                              <Option key={fy.value} value={fy.value}>
                                {fy.label}
                              </Option>
                            ))}
                          </Select>
                        </FormItem>
                      </Col>
                    </Row>
                  </Card>

                  <div style={{ marginTop: '20px' }}>
                    <FormItem>
                      <Space
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          justifyItems: ' center'
                        }}
                      >
                        <Button
                          loading={create_declaration_configLoading}
                          className={`${styles.ExceptionalApproval_button}`}
                          htmlType="submit"
                          size="small"
                        >
                          Submit
                        </Button>

                        <Button
                          className={`${styles.cancel_rejectModal_button}`}
                          size="small"
                          onClick={() =>
                            history.push('/declaration-configs-flow')
                          }
                        >
                          Cancel
                        </Button>
                      </Space>
                    </FormItem>
                  </div>
                </Form>
              </Card>
            </div>
          </div>
        </div>
      </Spin>
    </CustomLayout>
  );
}
export default CreateDeclarationConfigsFlow;
